import CreditScore from '../cards/credit-score';
import { PrimaryBorrowerEmail } from '../cards/email';
import LoanType from '../cards/loan-type';
import Occupancy from '../cards/occupancy';
import PurchasePrice from '../cards/purchase-price';
import TimeToPurchase from '../cards/time-to-purchase';
import WelcomeCard from '../cards/welcome/preapproval';
import { Card, End } from '../components/deck';
import coborrowerBranch from './branches/coborrower';
import { creditAuthorizationBranch } from './branches/credit-authorization';
import disqualifyingBranch from './branches/disqualifying';
import { DownPaymentBranch } from './branches/down-payment';
import { DownPaymentEvaluationBranch } from './branches/down-payment-evaluation';
import employmentBranch from './branches/employment';
import firstTimeBuyer from './branches/first-time-buyer';
import hasAgentBranch from './branches/has-agent';
import ownershipBranch from './branches/ownership';
import { PropertyTypeBranch } from './branches/property-type';
import { PreapprovalStateVerification } from './branches/state-verification';
import { VeteranStatusCompleted } from './branches/veteran-status-completed';

export default Card(
  WelcomeCard,
  PreapprovalStateVerification(
    PropertyTypeBranch(
      Card(
        Occupancy,
        VeteranStatusCompleted(
          Card(
            LoanType,
            Card(
              PurchasePrice,
              DownPaymentBranch(
                DownPaymentEvaluationBranch(
                  firstTimeBuyer(
                    'borrower',
                    ownershipBranch(
                      'borrower',
                      employmentBranch(
                        'borrower',
                        Card(
                          CreditScore,
                          coborrowerBranch(
                            disqualifyingBranch(
                              hasAgentBranch(
                                Card(
                                  TimeToPurchase,
                                  creditAuthorizationBranch(Card(PrimaryBorrowerEmail(), End()))
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/decks/preapproval.js